"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createTeamApi = void 0;
const react_1 = require("@reduxjs/toolkit/query/react");
/**
 * Team API factory — see createTicketApi.ts for the shared-package baseQuery-injection pattern.
 */
const createTeamApi = (baseQuery) => (0, react_1.createApi)({
    reducerPath: 'teamApi',
    baseQuery,
    tagTypes: ['Team', 'TeamList'],
    endpoints: (builder) => ({
        getTeamById: builder.query({
            query: (id) => ({
                url: 'Team',
                params: { id },
            }),
            providesTags: (_result, _error, id) => [{ type: 'Team', id }],
        }),
        getTeams: builder.query({
            query: ({ status } = {}) => ({
                url: 'Teams',
                params: status ? { status } : {},
            }),
            providesTags: ['TeamList'],
        }),
        getActiveTeams: builder.query({
            query: () => ({
                url: 'Teams',
                params: { status: 'ACTIVE' },
            }),
            providesTags: ['TeamList'],
        }),
        upsertTeam: builder.mutation({
            query: (body) => ({
                url: 'Team',
                method: 'POST',
                body,
            }),
            invalidatesTags: (_result, _error, arg) => [
                'TeamList',
                { type: 'Team', id: arg.teamView.id || 'NEW' },
            ],
        }),
    }),
});
exports.createTeamApi = createTeamApi;
